import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import type { Lead } from "@/app/services/generated/leadService";
import { leadService } from "@/app/services/generated/leadService";

export interface IHasLeadsCache {
  leads: LeadsCache;
}
// Singleton cache store
const leadsCacheStore = new EntityCacheStore<Lead>(
  EnumCacheEntityType.lead,
  async () => leadService.getAllLeads()
);

// Ephemeral reader
export default class LeadsCache extends EntityWithGuidKeyCache<Lead> {
  constructor() {
    super(leadsCacheStore, (x) => x.id);
  }
}
